import { useEffect } from 'react';

import { Constants } from '@constants';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconExclamationTriangleFilled } from '@iwoca/icons';
import { Card } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const Declined = () => {
    useEffect(() => {
        tracking.ampli.applicationDeclined();
    }, []);

    return (
        <Card className="flex flex-col items-center text-center min-l:p-2xl">
            <div className="rounded-m bg-secondary-95 p-l">
                <IconExclamationTriangleFilled className="size-3xl fill-secondary-60" />
            </div>
            <h1 className="text-2xl">
                <FormattedMessage
                    id="_.declined_view.title"
                    defaultMessage="Sorry, we can’t approve your application today."
                />
            </h1>
            <p>
                <FormattedMessage
                    id="_.declined_view.description"
                    defaultMessage="If you’d like to speak to us about the decision, or if you have any questions, give us a ring on {phoneNumber}."
                    values={{
                        phoneNumber: (
                            <a
                                href={Constants.PHONE_NUMBER.tel}
                                className="link"
                            >
                                {Constants.PHONE_NUMBER.display}
                            </a>
                        )
                    }}
                />
            </p>
        </Card>
    );
};
